import { Controller } from '@hotwired/stimulus'
import { purchasedCoursesFilter, sortingWidget } from 'cle/filter_widgets'
import CourseSearch from 'cle/course_search'
import { waitForQuimbeeDataKey } from 'controllers/quimbee_data_controller'
import SaveFilterSelectionsWidget from 'cle/save_filter_selections_widget'

export default class extends Controller {
  static values = {
    url: String,
    resultsContainerId: String,
    loadingDisableWith: String,
    purchasedCoursesIds: Array,
    preselectedJurisdictionsFilters: Array,
    preselectedPracticeAreaFilters: Array,
    preselectedCreditTypeFilters: Array,
    preselectedRatingFilters: Array,
    preselectedPresenterFilters: Array,
    preselectedCourseDifficultyFilters: Array,
    preselectedCourseTypeFilters: Array,
    presentersMap: Object,
    itemsPerPage: Number,
    topicsFiltersEnabled: Boolean,
    showCounters: Boolean,
    additionalFilters: { type: Boolean, default: false },
    purchasedFilter: { type: Boolean, default: false }
  }

  static targets = ["loadingIndicator"]

  async initialize() {
    await waitForQuimbeeDataKey("algolia")

    if (!window.instantsearch) {
      console.warn("Couldn't load Algolia instantsearch. CLE Courses Index Search component could not be initialized.")
      return
    }

    const courseSearch = new CourseSearch(this.searchOptions())
    courseSearch.init()
  }

  // To be overwritten by child classes.
  // Use `super.searchOptions()` to call this function from a child class.
  searchOptions() {
    const statsContainer = "#stats-container"
    const extraWidgets = []
    const facets = { jurisdictions: true, credit_types: true }

    extraWidgets.push(sortingWidget())

    facets.presenters = facets.rating = facets.practice_areas = facets.course_difficulty = facets.course_type = true

    if (this.purchasedFilterValue) {
      extraWidgets.push(purchasedCoursesFilter(this.purchasedCoursesIdsValue, this.resultsContainerIdValue))
    }

    extraWidgets.push(new SaveFilterSelectionsWidget())

    return {
      coursesUrl: this.urlValue,
      coursesContainerId: this.resultsContainerIdValue,
      loadingIndicator: this.loadingIndicatorTarget,
      loadingDisableWith: this.loadingDisableWithValue,
      purchasedCoursesIds: this.purchasedCoursesIdsValue,
      presentersMap: this.presentersMapValue,
      statsContainer: statsContainer,
      extraWidgets: extraWidgets,
      facets: facets,
      topicsFiltersEnabled: this.topicsFiltersEnabledValue,
      preselectedPracticeAreaFilters: this.preselectedPracticeAreaFiltersValue,
      preselectedJurisdictionsFilters: this.preselectedJurisdictionsFiltersValue,
      preselectedCreditTypeFilters: this.preselectedCreditTypeFiltersValue,
      preselectedRatingFilters: this.preselectedRatingFiltersValue,
      preselectedPresenterFilters: this.preselectedPresenterFiltersValue,
      preselectedCourseDifficultyFilters: this.preselectedCourseDifficultyFiltersValue,
      preselectedCourseTypeFilters: this.preselectedCourseTypeFiltersValue,
      showCounters: this.showCountersValue
    }
  }
}
